import { PROMO_ID_QUERYSTRING } from '../../../constants/promoIdQuery';
import { ISearchPromosV2ResponseSchema } from '../../../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { RedirectError } from '../../../utils/errors/RedirectError';
import { removeSearchParam } from '../../../utils/url/removeSearchParam';

interface IParams {
  path?: string;
}

export function assertRedirectError(response: ISearchPromosV2ResponseSchema, { path }: IParams) {
  const cleanPath = removeSearchParam({ path, param: PROMO_ID_QUERYSTRING });

  if (cleanPath !== response.path) {
    throw new RedirectError({
      domain: 'shared/services/promosSearch/assert/assertRedirectError#assertRedirectError()',
      message: 'response path is different from requested path',
      location: response.path,
      statusCode: 301,
    });
  }
}
